import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

const SIZE_MAP = {
  inline: { width: '1.1rem', height: '1.1rem' },
  block: { width: '2rem', height: '2rem' },
  page: { width: '3rem', height: '3rem' },
};

const AppSpinner = ({ size, label, className }) => {
  const wrapperClass =
    size === 'page'
      ? 'd-flex flex-column align-items-center justify-content-center gap-2 py-5'
      : 'd-flex align-items-center gap-2';

  return (
    <div className={`${wrapperClass} ${className}`}>
      <Spinner style={SIZE_MAP[size] || SIZE_MAP.inline} color="primary" />
      {label && <span className="app-text-muted mb-0">{label}</span>}
    </div>
  );
};

AppSpinner.propTypes = {
  size: PropTypes.oneOf(['inline', 'block', 'page']),
  label: PropTypes.string,
  className: PropTypes.string,
};

AppSpinner.defaultProps = {
  size: 'inline',
  label: '',
  className: '',
};

export default AppSpinner;
